export enum Debtor {
  PRIMARY = 'primary',
  SECONDARY = 'secondary'
}
